module.exports = __webpack_public_path__ + "img/Cayman Islands.e43969e8.svg";